module.exports = __webpack_public_path__ + "static/media/calendar-with-clock-24.df63f835.svg";